<template>
  <span class="group relative inline-flex items-center gap-1 cursor-default" :title="text">
    <span class="break-words">{{ text || '-' }}</span>
    <button
      v-if="text !== '-' && text.length"
      type="button"
      class="inline-flex shrink-0 items-center justify-center transition-opacity duration-150 text-gray-400 hover:text-primary focus:outline-none"
      :title="copied ? 'Copied!' : 'Copy'"
      @click.stop.prevent="copyText"
    >
      <fa-icon v-if="!copied" :icon="faCopy" class="w-3.5 h-3.5" />
      <fa-icon v-else :icon="faCheck" class="w-3.5 h-3.5 text-green-500" />
    </button>
  </span>
</template>

<script>
import { faCopy, faCheck } from '@fortawesome/free-solid-svg-icons'
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'SwdCopyText',
  props: {
    text: {
      type: String,
      required: true,
      default: '',
    },
  },
  setup(props) {
    const copied = ref(false)
    let resetTimer = null

    async function copyText() {
      if (!props.text) {
        return
      }
      try {
        await navigator.clipboard.writeText(props.text)
        copied.value = true
        clearTimeout(resetTimer)
        resetTimer = setTimeout(() => {
          copied.value = false
        }, 2000)
      } catch {
        // fallback for older browsers
        const el = document.createElement('textarea')
        el.value = props.text
        el.style.position = 'fixed'
        el.style.opacity = '0'
        document.body.appendChild(el)
        el.select()
        document.execCommand('copy')
        document.body.removeChild(el)
        copied.value = true
        clearTimeout(resetTimer)
        resetTimer = setTimeout(() => {
          copied.value = false
        }, 2000)
      }
    }

    return { copied, copyText, faCopy, faCheck }
  },
})
</script>
